export default {

  categoryList: {items: [], _links: {}, _meta: {}},

}
